import * as THREE from 'three';

const UNIT_DIVISOR = 2;

export function getBoxMeshData({ dimensions, coordinates, color }) {
  const shrinked = {
    length: dimensions.length / UNIT_DIVISOR,
    height: dimensions.height / UNIT_DIVISOR,
    width: dimensions.width / UNIT_DIVISOR,
  };

  const position = [
    (coordinates[0] + dimensions.length) / 2 - shrinked.length / 2,
    coordinates[2] - shrinked.height / 2,
    (coordinates[1] + dimensions.width) / 2 - shrinked.width / 2,
  ];

  const geometry = new THREE.BoxGeometry(shrinked.length, shrinked.height, shrinked.width);
  geometry.translate(...position);

  const colorObj = new THREE.Color(color);
  const vertexCount = geometry.attributes.position.count;
  const colors = new Float32Array(vertexCount * 3);

  for (let i = 0; i < vertexCount; i++) {
    colors[i * 3] = colorObj.r;
    colors[i * 3 + 1] = colorObj.g;
    colors[i * 3 + 2] = colorObj.b;
  }

  geometry.setAttribute('color', new THREE.BufferAttribute(colors, 3));
  return { geometry };
}
